/* eslint-disable */
/*eslint-enable*/
import React, { useReducer, FC, ReactNode, createContext } from 'react';
import LanguageReducer from './languageReducer';
import en from './en.json';
import nl from './nl.json';
import es from './es.json';
import fr from './fr.json';
import hn from './hn.json';
import id from './id.json';
import it from './it.json';
import th from './th.json';
import vi from './vi.json';
import zh from './zh-tw.json';

interface LangStateProps {
  children: ReactNode;
}

export const CHANGE_LANGUAGE = "change_language"

export const LanguageContext = createContext({})

const LanguageState: FC<LangStateProps> = ({ children }) => {
  const initialState = {
    language: en,
    code:''
  };

  const [state, dispatch] = useReducer(LanguageReducer, initialState);
  const setLanguage = (lang: string) => {
    // API call can be set to get the data for selected language

    switch (lang) {
      case 'en':
        return dispatch({
          type: CHANGE_LANGUAGE,
          payload: en,
        });
      case 'es':
        return dispatch({
          type: CHANGE_LANGUAGE,
          payload: es,
        });
      case 'fr':
        console.log('Inside');
        return dispatch({
          type: CHANGE_LANGUAGE,
          payload: fr,
        });
      case 'hn':
        console.log('Inside');
        return dispatch({
          type: CHANGE_LANGUAGE,
          payload: hn,
        });
      case 'id':
        console.log('Inside');
        return dispatch({
          type: CHANGE_LANGUAGE,
          payload: id,
        });
      case 'it':
        console.log('Inside');
        return dispatch({
          type: CHANGE_LANGUAGE,
          payload: it,
        });
      case 'nl':
        console.log('Inside');
        return dispatch({
          type: CHANGE_LANGUAGE,
          payload: nl,
        });

      case 'th':
        console.log('Inside');
        return dispatch({
          type: CHANGE_LANGUAGE,
          payload: th,
        });
      case 'vi':
        console.log('Inside');
        return dispatch({
          type: CHANGE_LANGUAGE,
          payload: vi,
        });
      case 'zh-tw':
        console.log('Inside');
        return dispatch({
          type: CHANGE_LANGUAGE,
          payload: zh,
        });

      default:
        return dispatch({
          type: CHANGE_LANGUAGE,
          payload: en,
        });
    }
  };

  return (
    <LanguageContext.Provider
      value={{ state, dispatch: { setLanguage } }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageState;
